import { render, staticRenderFns } from "./Externos.vue?vue&type=template&id=4a18d536&"
import script from "./Externos.vue?vue&type=script&lang=js&"
export * from "./Externos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports